import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { FiDateTimeFormatOptions } from '@fi-shared/utils';

@Component({
    selector: 'fi-checklist-progress-stepper-bar',
    template: `
        <div class="fi-checklist-progress-stepper-bar" [class.inactive]="inactive">
            <div class="progress-place clearfix">
                <div [style.width]="progressWidth" class="progress-bar"></div>
            </div>

            <div class="progress-text">
                {{ getProgressText() }}
            </div>

            <div class="progress-description">
                {{ progressDescription }}
            </div>
        </div>
    `,
    styleUrls: ['./progress-stepper-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiChecklistProgressStepperBarComponent implements OnInit, OnChanges {
    @Input() totalCheckpoints: number = 0;
    @Input() completedCheckpoints: number = 0;
    @Input() inactive: boolean = false;
    @Input() startDateTimeStr: string;
    @Input() isEnded: boolean;

    constructor(
        private appTextService: AppTextService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    ngOnInit() {
        this.updateWithChanges();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.updateWithChanges();
    }

    percentsCompleted: number = 0;
    progressWidth: string = '0px';
    progressDescription: string = '';

    updateWithChanges() {
        this.percentsCompleted =
            this.totalCheckpoints === 0 ? 100 : Math.round((this.completedCheckpoints / this.totalCheckpoints) * 100);
        this.progressWidth = this.percentsCompleted + '%';
        const checkpointsLeft = this.totalCheckpoints - this.completedCheckpoints;
        let descriptionTextId = '';
        if (checkpointsLeft === 1) descriptionTextId = 'checklist.checkpoints_left_single';
        else if (checkpointsLeft === 0) descriptionTextId = 'checklist.all_done';
        else descriptionTextId = 'checklist.checkpoints_left_multiple';
        this.progressDescription = this.appTextService.get(descriptionTextId, { '{n}': checkpointsLeft });
    }

    getProgressText() {
        if (!this.inactive) return this.percentsCompleted + '%';
        if (this.isEnded) return this.appTextService.get('checklist.ended');
        return this.appTextService.get('checklist.available_from', {
            '{0}': this.fiFormatDateService.formatDate(this.startDateTimeStr, FiDateTimeFormatOptions, {
                showToday: false,
                showUTC: true,
            }),
        });
    }
}
